import type { RawPoint } from './periodicChartBuilder';

const WEEK = 7 * 86400000;
/** UTC Monday buckets; retain the winning workout's actual date and metadata. */
export function weeklyPeaks(points: RawPoint[], lowerIsBetter = false): RawPoint[] {
  const weeks = new Map<number, RawPoint>();
  for (const point of points) {
    if (!Number.isFinite(point.x) || !Number.isFinite(point.y)) continue;
    const week = Math.floor((point.x - 4 * 86400000) / WEEK);
    const previous = weeks.get(week);
    if (!previous || (lowerIsBetter ? point.y < previous.y : point.y > previous.y)) weeks.set(week, point);
  }
  return [...weeks.values()].sort((a, b) => a.x - b.x);
}
